import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Dropdown, Drawer, Typography } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import { useAppSelector } from '../../store/hooks'
import { selectAuthUserSlice } from '../../store/auth-user-slice'
import { selectAuthCompanySlice } from '../../store/auth-company-slice'
import { UserAvatar } from '@vacationtracker/shared/components/user-avatar'
import SidebarContent from '../Sidebar/SidebarContent'
import { useProfileMenuItems } from '../../hooks/use-profile-menu-items'

import VTLogoPurple from '../../assets/images/VT-Logo-Purple.svg'

interface IMobileHeader {
  onLogout: Function
}

const MobileHeader = ({ onLogout }: IMobileHeader): React.ReactElement => {
  const { authUser } = useAppSelector(selectAuthUserSlice)
  const { authCompany } = useAppSelector(selectAuthCompanySlice)
  const [drawerVisible, setDrawerVisible] = useState(false)

  // Use shared profile menu hook
  const { profileMenuItems, energyScore, shouldShowEnergyScore } = useProfileMenuItems({
    onLogout: () => onLogout(),
  })

  const onToggleDrawer = () => {
    setDrawerVisible(!drawerVisible)
  }

  const onCloseDrawer = () => {
    setDrawerVisible(false)
  }

  return (
    <>
      <div className="mobile-header">
        {/* Left side - Hamburger menu */}
        <div className="mobile-header-left">
          <Button
            className="mobile-hamburger-btn"
            type="text"
            icon={<MenuOutlined />}
            onClick={onToggleDrawer}
          />
          <Link to="/app/dashboard" className="mobile-header-logo">
            <VTLogoPurple />
          </Link>
        </div>

        {/* Right side - User profile */}
        <div className="mobile-header-right">
          <Dropdown
            menu={{ items: profileMenuItems, className: 'mobile-profile-menu sidebar-profile-menu' }}
            trigger={['click']}
            placement="bottomRight"
            overlayStyle={{
              position: 'fixed',
              top: '64px',
              right: '16px',
              transform: 'none',
            }}
          >
            <Button type="text" className="mobile-profile-button">
              <div className="mobile-profile-wrapper">
                <div className="mobile-profile-info">
                  <Typography.Text className="mobile-profile-name">{authUser.name}</Typography.Text>
                  <Typography.Text className="mobile-profile-company" type="secondary">{authCompany?.name}</Typography.Text>
                </div>
                <UserAvatar
                  id={authUser.id}
                  name={authUser.name}
                  className="mobile-profile-avatar"
                  shape="circle"
                  avatarSize="small"
                  avatar={authUser.imageUrl}
                  showEnergy={shouldShowEnergyScore}
                  energyScore={energyScore}
                />
              </div>
            </Button>
          </Dropdown>
        </div>
      </div>

      {/* Mobile Navigation Drawer */}
      <Drawer
        className="mobile-navigation-drawer"
        placement="left"
        closable={false}
        onClose={onCloseDrawer}
        open={drawerVisible}
        width={280}
        styles={{
          body: { padding: 0 },
        }}
      >
        <SidebarContent onLogout={onLogout} isMobileDrawer={true} onItemClick={onCloseDrawer} />
      </Drawer>
    </>
  )
}

export default MobileHeader
